export const EndpointMocks = {
  SKYMILES: {
    SKYMILES_API_ACCOUNT_ACTIVITY:
      '/accountactivitysvc/accountActivity/recentActivity',
    SKYMILES_API_ECREDITS: '/payment/eDocuments/search',
    SKYMILES_API_MEMBERSHIP_CARD:
      '/skymilesdocsvc/skymilesDoc/getSkymileCardURL',
    SKYMILES_API_PROMOTIONS:
      'https://loyalty-api-dev.delta.com/loyaltyPromotions/v1/myPromotions?requestTypeCode=All&categoryTypeCode=Partners Only',
    SKYMILES_API_STATUS_TRACKER:
      '/statustrackersvc/statusTracker/medallionStatus',
    SKYMILES_API_VOUCHERS: '/skymilesdocsvc/skymilesDoc/getVoucher',
    SKYMILES_AEM_AUTH_CONFIG:
      '/content/dam/delta-applications/nextgenskymiles/auth-config.json',
    SKYMILES_AEM_LANDING_PAGE_MEDALLION_BANNER:
      '/content/www/accountmanagement/nextgenskymiles/medallion-banner.skymilesdata.json',
    SKYMILES_AEM_LANDING_PAGE_MENU:
      '/content/www/accountmanagement/nextgenskymiles/side-navigation.skymilesdata.json',
    SKYMILES_AEM_LANDING_PAGE_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/landing-page-feature-flags.skymilesFeatureFlags.json',
    SKYMILES_AEM_LANDING_PAGE_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/landing-page-error-messages.skymilesdata.json',
    SKYMILES_AEM_PARTNERS_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/partners-error-messages.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/overview-content.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_MAIN_CONTENT:
      '/content/www/accountmanagement/nextgenskymiles/nextgen-overview.ngmyskymilesdata.json',
    SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES:
      '/content/www/accountmanagement/nextgenskymiles/overview-error-messages.skymilesdata.json',
    SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/feature-flag.skymilesFeatureFlags.json',
    SKYMILES_AEM_OVERVIEW_WELCOME_TOUR:
      '/content/www/accountmanagement/nextgenskymiles/overview-welcome-tour.skymilesdata.json',
    SKYMILES_AEM_PROMOTIONS_CONTENT:
      '/content/www/accountmanagement/nextgenpromotions/promotions.promotiondata.json',
    SKYMILES_AEM_PROMOTIONS_ERROR_MESSAGES:
      '/content/dam/delta-applications/nextgenskymiles/pages/promotions/error-messages.json',
    SKYMILES_AEM_PROMOTIONS_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/promotions-feature-flag.skymilesFeatureFlags.json',
    SKYMILES_PROMOTIONS_MAIN_API:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/myPromotions?requestTypeCode=All&categoryTypeCode=All',
    SKYMILES_PROMOTIONS_ENROLL_API:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/enrollment?enrollmentMethodTypeCode=promotionCode',
    SKYMILES_PROMOTIONS_DETAILS_API:
      'https://loyalty-api-si.delta.com/loyaltyPromotions/v1/mypromotions/rewards',
    SKYMILES_PROMOTIONS_CONTENT_API: 'https://content-api-si.delta.com/graphql',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_CONTENT:
      '/content/dam/delta-applications/nextgenskymiles/pages/account-activity/content.json',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_ERROR_MESSAGES:
      '/content/dam/delta-applications/nextgenskymiles/pages/account-activity/error-messages.json',
    SKYMILES_AEM_ACCOUNT_ACTIVITY_FEATURE_FLAGS:
      '/content/dam/delta-applications/nextgenskymiles/pages/account-activity/feature-flags.json',
    SKYMILES_AEM_BUSINESS_TRAVELER_FEATURE_FLAGS:
      '/content/www/accountmanagement/nextgenskymiles/accountactivityfflags.skymilesFeatureFlags.json',
    SKYMILES_API_BUSINESS_TRAVELER_CUSTOMER_PROFILE:
      'https://customer-api-si.delta.com/profile/graphql'
  }
};
